export default {
  SEARCH_KUSPIT_EARNINGS_REPORT_QUERY: Symbol.for('SEARCH_KUSPIT_EARNINGS_REPORT_QUERY'),
  KUSPIT_EARNINGS_REPORT_REPOSITORY: Symbol.for('KUSPIT_EARNINGS_REPORT_REPOSITORY'),
};
